/**
 * LESA Public JS
 */

// Import our imports
import $ from 'jquery';
import select2 from 'select2';

(function () {
	console.log('LESA frontend JS loaded.');

	if ($('.js-accordion').length) {
		initAccordions();
	}

	if ($('.js-select2-multiple').length) {
		initSelect2();
	}

	initLibraryFilters();
}());

function initLibraryFilters() {
	$('.js-area-of-law-checkbox').on('change', function(e) {
		const isChecked = $(this).prop('checked');
		const children = $(this).closest('.js-area-of-law-option').find('.js-area-of-law-children');

		if (isChecked === true) {
			children.fadeIn();
		} else {
			children.hide();
		}
	});
}

function initSelect2 () {
	$('.js-select2-multiple').select2({
		tags: true,
		placeholder: 'Type to search',
	}).on('change', function () {
		let $selected = $(this).find('option:selected');
		const $container = $(this).siblings('.js-author-tags-container');

		let $list = $('<ul>');
		$selected.each(function (k, v) {
			let $li = $('<li><span class="tag-selected"><a class="destroy-tag-selected">×</a>' + $(v).text() + '</span></li>');
			$li.find('a.destroy-tag-selected')
				.off('click.select2-copy')
				.on('click', function (e) {
					console.log('clicked destroy-tag link');
					let $opt = $(this).data('select2-opt');
					console.log($opt);
					$opt.prop('selected', false);
					$opt.parents('select').trigger('change');
				}).data('select2-opt', $(v));
			$list.append($li);
		});
		$container.html('').append($list);
	}).trigger('change');
}

function initAccordions () {
	console.log('init accordions.');
	$('body').on('click', '.js-accordion .js-accordion-toggle', function (j) {
		const dropDown = $(this).closest('.js-accordion-item').find('.js-accordion-content');

		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
		} else {
			$(this).addClass('active');
		}

		dropDown.stop(false, true).slideToggle();

		j.preventDefault();
	});
}
